import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Form, Field } from 'react-final-form'

import userActions from '../../context/users/actions';
import { ToastContainer, notify } from '../../libraries/notifications';
import { composeValidators, validateEmail, validateIsfilled, getTimeZone, validateOnlyNumber, capitalize, formatOnlyNumberInput, isDate, months, isEmptyObject, dateComponents, getObjectWithJsonDataToFormValues } from '../../libraries/utils';

import { history } from '../../routes';
import config from '../../config';

import LayoutSmall from '../../components/layout/LayoutSmall';
import Button from '../../components/commons/Button';
import TextInput from '../../components/forms/TextInput';
import CheckboxInput from '../../components/forms/CheckboxInput';

import SelectInput from '../../components/forms/SelectInput';
import insurancesActions from '../../context/insurances/actions';
import MultiSelectInput from '../../components/forms/MultiSelectInput';
import { zonedTimeToUtc } from 'date-fns-tz';
import BirthDateInput from '../../components/forms/BirthDateInput';

class Signup extends React.Component {
  constructor(props) {
    super(props);
    this.t = this.props.t;
    this.state = {
      submitting: false,
      signupData: {},
      insurances: [],
      preRegistered: false,
      loading: true,
    }
  }

  componentDidMount() {
    this.getInsurances();
    if (isEmptyObject(this.props.location.state)) {
      history.push(config.ROUTES.HOME);
      return
    }
    else {
      let { valuesFromVerification, preRegistered } = this.props.location.state;
      if (!valuesFromVerification) {
        history.push(config.ROUTES.HOME);
        return
      }

      const ins = this.state.insurances.find(insurance => insurance.rnos === valuesFromVerification.insurance);
      if (ins) {
        valuesFromVerification.insurance = [{ value: ins.rnos, label: ins.name }]
      } else {
        valuesFromVerification.insurance = []
      }
      this.setState({ signupData: valuesFromVerification, preRegistered, loading: false })
      //initial values
    }
  }

  getInsurances = async () => {
    await this.props.onGetAllInsurances();
    const { insurances } = this.props;
    if (insurances.error) {
      notify(this.t(insurances.error.message));
    } else {
      this.setState({ insurances: insurances.items });
    }
  }

  onSubmit = async (values) => {
    this.setState({ submitting: true, signupData: { ...values } });
    const data = { ...values, time_zone: getTimeZone(), user_type: config.USER_TYPE.PATIENT, role: config.USER_TYPE.PATIENT }

    if (values.insurance.length) data.insurance = values.insurance[0].value
    data.insurance = this.state.insurances.find(x => x.id === data.insurance)?.rnos

    data.birth_date = dateComponents(values.birth_date)[3].dateOnly
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const utcDate = zonedTimeToUtc(data.birth_date, timeZone)
    data.birth_date = utcDate

    if(!this.state.preRegistered){ 
      await this.props.onRegister(data)
      const user = this.props.user;
      if (user.error) {
        this.setState({ submitting: false })
        if (user.error.message.includes("credentials")) {
          notify(this.t("Ya existe una cuenta con ese mail"));
        } else {
          notify(this.t(user.error.message));
        }
      } else {
        history.push(config.ROUTES.VERIFY.replace(':hash', this.props.user.item.hash));
      }
    }
    else{
      delete data.email;
      delete data.role;
      delete data.terms;
      await this.props.onRegister({id: data.id, ...data});
      const user = this.props.user;
      if (user.error) {
        this.setState({ submitting: false });
        notify(this.t(user.error.message));
      } else {
        history.push(config.ROUTES.VERIFY.replace(':hash', this.props.user.item.hash));
      }
    }
  }

  onTerms = () => {
    history.push(config.ROUTES.TERMS, { from: this.props.location });
  }

  onLogin = () => {
    history.push(config.ROUTES.LOGIN);
  }
  render() {
    const { insurances, signupData } = this.state;
    // console.log('signupData birthdate', signupData.birth_date, signupData.birth_date)
    const required = value => (validateIsfilled(value) ? undefined : this.t("This field is required"))
    const required_date = value => (isDate(value) ? undefined : this.t("This field is required"))
    const email = value => (validateEmail(value) ? undefined : this.t("Not a valid email"))
    const onlynumber = value => (validateOnlyNumber(value) ? undefined : this.t("El documento solo debe llevar digitos"))
    const dnilength = value => (value.length >= 7 && value.length <= 8 ? undefined : this.t("El documento debe tener 7 u 8 numeros"))

    const dni_types = config.OPTIONS.SINGUP.IDENTIFICATION.TYPES.map((o) => { return { value: o, label: this.t(o) } });
    const gender_types = config.OPTIONS.SINGUP.GENDER.TYPES.map((o) => { return { value: o, label: capitalize(o) } });

    const insurances_list = insurances.map((o) => { return { value: o.id, label: o.name } });

    const today = new Date()
    return (
      <LayoutSmall
        main={{ className: "bg-base-200 text-primary bg-pattern" }}
        header={{
          title: this.t("Register"),
          className: "!bg-transparent !text-primary",
        }}
        container={{
          className: "mt-10",
        }}
        loading={this.state.loading}
      >
        <ToastContainer />
        <Form
          initialValues={signupData || {}}
          onSubmit={this.onSubmit}
        >
          {({ handleSubmit, form, submitting, pristine, values }) => (
            <>
              <form onSubmit={handleSubmit} className="w-full max-w-lg mx-auto px-4">
                <div className="w-full">
                  <Field
                    name="first_name"
                    component={TextInput}
                    placeholder={this.t("Ej. Juan")}
                    label={this.t("Nombre")}
                    validate={required}
                    readOnly
                  />
                </div>
                <div className="w-full">
                  <Field name="last_name" component={TextInput} placeholder={this.t("Ej. Sosa")} label={this.t("Apellido")} validate={required} readOnly />
                </div>


                <div className="flex">
                  <div className="w-1/3 mr-3">
                    <Field name="identification_type" component={SelectInput} placeholder={this.t("Tipo")} label={this.t("Tipo de Doc.")} validate={required}
                      options={dni_types}
                      empty={this.t("Seleccione")}
                      readOnly
                    />
                  </div>
                  <div className="w-2/3">
                    <Field name="identification" parse={v => formatOnlyNumberInput(v, 8)} component={TextInput} placeholder={this.t("Nro de Documento")} label={this.t("Nro de Documento")} validate={composeValidators(required, onlynumber, dnilength)} />
                  </div>
                </div>
                {signupData.birth_date && <Field 
                    name="birth_date" 
                    component={BirthDateInput}
                    label={this.t("Fecha de nacimiento")}
                    initialValue={signupData.birth_date}
                    allowNull={true}
                    readOnly
                />}
                {!signupData.birth_date && <Field 
                    name="birth_date" 
                    component={BirthDateInput}
                    label={this.t("Fecha de nacimiento")}
                    allowNull={true}
                    readOnly
                />}
                <div className="flex">
                  <div className="w-1/2 mr-3">
                    <Field name="gender" component={SelectInput} placeholder={this.t("Genero")} label={this.t("Género")} validate={required}
                      options={gender_types}
                      empty={this.t("Seleccione")}
                      readOnly
                    />
                  </div>
                </div>

                <div className="w-full">
                  <Field name="email" component={TextInput} placeholder={this.t("Ej. mail@mail.com")} label={this.t("Correo electrónico")} validate={composeValidators(required, email)} readOnly={this.state.preRegistered} />
                </div>
                <div className="w-full">
                  <Field name="phone" parse={v => formatOnlyNumberInput(v, 11)} component={TextInput} placeholder={this.t("Cod de área sin el 15")} label={this.t("Teléfono")} validate={required} />
                </div>



                {insurances_list.length && <div className="w-full">
                  <Field
                    name="insurance"
                    component={MultiSelectInput}
                    label={this.t("Obra Social")}
                    placeholder={this.t("Obra Social")}
                    options={insurances_list}
                    empty={this.t("Seleccione")}
                    // validate={required} disabled={newPatient}
                    inputClassName="input-bordered shadow-none"
                    disableSelectAll={true}
                    single={true}
                  />
                </div>}
                <div className="flex mb-3">
                  <Field
                    name="insurance_number"
                    component={TextInput}
                    placeholder={this.t("Nro. de Socio")}
                    label={this.t("Nro. de Socio")}
                    validate={composeValidators(required)}
                    inputClassName="input-bordered shadow-none"
                  />
                </div>

                <div className="w-full mb-3 md:mb-0">
                  <Field name="terms" component={CheckboxInput} label={this.t("I accept terms and conditions")}
                    validate={required}
                    checkboxClassName="checkbox-primary"
                    type="checkbox"
                  />
                </div>

                <div className="w-full">
                  <Button
                    className="btn-primary btn-block"
                    title={this.t("Next")}
                    type='submit'
                    // onClick={handleSubmit}
                    //disabled={this.state.submitting || pristine}
                  />
                </div>
              </form>
            </>
          )}
        </Form>
        <div className="w-full px-3 mt-5">
          <Button
            className="btn-link btn-block underline"
            title={this.t("Terms and conditions")}
            onClick={this.onTerms}
          />
        </div>
        <div className="mt-2 p-2 flex justify-center items-center">
          <p className="text-center mr-1">{this.t("Has an account?")}</p>
          <Button
            className="btn-link mb-0 underline"
            title={this.t("Login with your user")}
            onClick={this.onLogin}
          />
        </div>
      </LayoutSmall>
    )
  }
}

const mapStateToProps = state => {
  return {
    user: state.users.current,
    insurances: state.insurances.list,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onRegister: (params) => dispatch(userActions.saveOrUpdate(params, 'register')),
    onGetFromHash: (params) => dispatch(userActions.getFromHash(params)),
    onGetAllInsurances: (params) => dispatch(insurancesActions.getAll(params)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(Signup));
